export default __webpack_public_path__ + "static/media/clear-overview-search.aeb9e90e.svg";